// 弹窗自由拉伸和拖拽指令
import Vue from 'vue'

const EDGE_OFFSET = 10

function getDialogStyle(dialog) {
  return dialog.currentStyle || window.getComputedStyle(dialog, null)
}

function getResizeDirection(dialogWrap, dragDom, e) {
  const rect = dragDom.getBoundingClientRect()
  const clientY = e.clientY + dialogWrap.scrollTop
  const top = rect.top + dialogWrap.scrollTop
  const leftEdge =
    e.clientX >= rect.left && e.clientX <= rect.left + EDGE_OFFSET
  const rightEdge =
    e.clientX <= rect.right && e.clientX >= rect.right - EDGE_OFFSET
  const bottomEdge =
    clientY >= top + dragDom.clientHeight - EDGE_OFFSET &&
    clientY <= top + dragDom.clientHeight

  return {
    left: leftEdge,
    right: rightEdge,
    bottom: bottomEdge,
    active: leftEdge || rightEdge || bottomEdge
  }
}

Vue.directive('dialogDragStretch', {
  bind(el) {
    const minWidth = 500
    const minHeight = 300
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')

    if (!dialogHeaderEl || !dragDom) return

    dialogHeaderEl.insertAdjacentHTML(
      'beforeEnd',
      '<div class="bigbtn"><div class="changeBig"></div><div class="changeSmall"></div></div>'
    )
    dragDom.style.overflow = 'auto'
    dialogHeaderEl.style.cursor = 'move'

    const restoreSelectable = () => {
      dragDom.style.removeProperty('user-select')
      dragDom.style.removeProperty('-webkit-user-select')
      dragDom.style.removeProperty('-moz-user-select')
      dragDom.style.removeProperty('-ms-user-select')
    }

    const moveDown = (e) => {
      const sty = getDialogStyle(dragDom)
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      const dragDomWidth = dragDom.offsetWidth
      const dragDomHeight = dragDom.offsetHeight
      const screenWidth = document.body.clientWidth
      const screenHeight = document.body.clientHeight
      const minDragDomLeft = dragDom.offsetLeft
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth
      const minDragDomTop = dragDom.offsetTop
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight

      let styL
      let styT

      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }

      document.onmousemove = function (evt) {
        let left = evt.clientX - disX
        let top = evt.clientY - disY

        if (-left > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-top > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
      }

      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    dialogHeaderEl.onmousedown = moveDown

    dragDom.onmousemove = function (e) {
      const resizeDirection = getResizeDirection(el, dragDom, e)

      if (resizeDirection.left || resizeDirection.right) {
        dragDom.style.cursor = 'w-resize'
      } else if (resizeDirection.bottom) {
        dragDom.style.cursor = 's-resize'
      } else {
        dragDom.style.cursor = ''
      }
    }

    dragDom.onmousedown = (e) => {
      const resizeDirection = getResizeDirection(el, dragDom, e)

      // 只有命中边缘拉伸区时，才接管鼠标事件，正文区域仍允许选中文本
      if (!resizeDirection.active) return

      const clientX = e.clientX
      const clientY = e.clientY
      const elW = dragDom.clientWidth
      const elH = dragDom.clientHeight
      const scrollTop = el.scrollTop

      dragDom.style.userSelect = 'none'
      dragDom.style.webkitUserSelect = 'none'
      dragDom.style.MozUserSelect = 'none'
      dragDom.style.msUserSelect = 'none'

      document.onmousemove = function (evt) {
        evt.preventDefault()

        if (resizeDirection.left) {
          if (clientX > evt.clientX) {
            dragDom.style.width = elW + (clientX - evt.clientX) * 2 + 'px'
          }
          if (clientX < evt.clientX && dragDom.clientWidth >= minWidth) {
            dragDom.style.width = elW - (evt.clientX - clientX) * 2 + 'px'
          }
        }

        if (resizeDirection.right) {
          if (clientX > evt.clientX && dragDom.clientWidth >= minWidth) {
            dragDom.style.width = elW - (clientX - evt.clientX) * 2 + 'px'
          }
          if (clientX < evt.clientX) {
            dragDom.style.width = elW + (evt.clientX - clientX) * 2 + 'px'
          }
        }

        if (resizeDirection.bottom) {
          const currentY = scrollTop + evt.clientY
          const startY = scrollTop + clientY

          if (startY > currentY && dragDom.clientHeight >= minHeight) {
            dragDom.style.height = elH - (startY - currentY) + 'px'
          }
          if (startY < currentY) {
            dragDom.style.height = elH + (currentY - startY) + 'px'
          }
        }
      }

      document.onmouseup = function () {
        restoreSelectable()
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
